import Sidebar from '../../produto/shared-components/sidebar/Sidebar';

export default Sidebar;
